import React from 'react'
import { Button, Col, Form, Input, Row } from 'reactstrap'
import { FaArrowRight } from 'react-icons/fa6'
import { FiMapPin } from "react-icons/fi";
import { SiMapillary } from "react-icons/si";
import { BiPhone } from 'react-icons/bi'
import { CgMail } from 'react-icons/cg'
import { Link } from 'react-router-dom'

const ContactForm = () => {
    return (
        <div className='contact-form'>
            <Row className='content'>
                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='mb-4'>
                    <div className='left'>
                        <div className='description'><span>With us it happens</span></div>
                        <div className='description'><span>We would love to hear from you.</span></div>
                        <div className='company-info'>
                            <div className='item'>
                                <div className='icon'><FiMapPin size={20} /></div>
                                <div className='title'><strong>Centre Office</strong></div>
                                <div className='desc'><span>Reşit Galip Cd. No: 56/2 Kazım Özalp Mh. GOP Cankaya Ankara, 06700 Turkey</span></div>
                            </div>
                            <div className='item'>
                                <div className='icon'><FiMapPin size={20} /></div>
                                <div className='title'><strong>R&D Office</strong></div>
                                <div className='desc'><span>Teknokent Administrative Building and Offices Çankırı TGB ÇAKÜ Teknokent Building No: 4 Interior Door No: 3010 Centre Çankırı</span></div>
                            </div>
                            <div className='phone-mail d-flex justify-content-start'>
                                <div className='item'>
                                    <div className='icon'><BiPhone size={20} /></div>
                                    <div className='desc'><Link to="tel:+90 312 437 0 222"><span>+90 312 437 0 222</span></Link></div>
                                    <div className='desc mt-2'><Link to="tel:+90 533 659 4 202"><span>+90 533 659 4 202</span></Link></div>
                                </div>
                                <div className='item'>
                                    <div className='icon'><CgMail size={20} /></div>
                                    <div className='desc'><Link to="mailto:bilgi@liberyus.com"><span>bilgi@liberyus.com</span></Link></div>
                                </div>
                            </div>
                            <Link to="https://maps.app.goo.gl/1nhgdYHfWMY7d2T88" target="_blank" className='map' style={{textDecoration:"none" ,listStyle:"none"}}>   
                            <div className='direction'><SiMapillary size={15} /><strong style={{color:"rgba(51, 92, 255, 1)"}}>Get Directions</strong></div></Link>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='mb-4'>
                    <div className='right'>
                        <Form>
                            <div className='form-field'>
                                <div><label>Name and Surname</label><span className='warning'>*</span></div>
                                <div><Input type='text' placeholder='John Doe' /></div>
                            </div>
                            <div className='form-field'>
                                <div><label>E-Mail</label><span className='warning'>*</span></div>
                                <div><Input type='text' placeholder='john.doe@email.com' /></div>
                            </div>
                            <div className='form-field'>
                                <div><label>Phone</label><span className='warning'>*</span></div>
                                <div><Input type='text' placeholder='0(555) 555 5555' /></div>
                            </div>
                            <div className='form-field'>
                                <div><label>Company Name</label><span className='warning'></span></div>
                                <div><Input type='text' placeholder='Your company name' /></div>
                            </div>
                            <div className='form-field'>
                                <div><label>Your Project is About</label><span className='warning'>*</span></div>
                                <div><Input type='textarea' placeholder='Placeholder text' /></div>
                            </div>
                            <Button className='send'><FaArrowRight size={20} /><span>Send</span></Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default ContactForm
